import React, { createContext, useContext, useEffect, useState } from 'react'
import ErrorTooltip from 'Components/ErrorTooltip';
import ToolTip from 'Components/ToolTip';
import { TooltipMsg } from 'Components/ToolTipMessage';
import { Field, FieldProps, useFormikContext } from 'formik';
import { Card, CardBody, CardHeader, Col, Input, Label, Row } from 'reactstrap';
import env from "environment_system/env_system";
import { ReportingEvents, VesselTypeConstant } from 'shared/constants';
import PopOver from 'Components/PopOver';
import { useSelector } from 'react-redux';
import { RootState } from 'index';
import PopUp from 'Components/PopUp';
import LNGCargoQuality from 'Components/LNGCargoQuality';
import { checkValidObject } from 'GenericForms/Helper';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';

const LoadingCTMSContext = createContext(null);
const DischargingCTMSContext = createContext(null);
export const UpdateLoadingCTMS = () => {
    return useContext(LoadingCTMSContext);
};

export const UpdateDischargingCTMS = () => {
    return useContext(DischargingCTMSContext);
};

interface CargoDetailsProps {
    alertBool: boolean;
    handleCargoOnboardBlur: any,
    updateTotalCargoOnboard: any,
    setLoadingPopOverBool: any,
    setLoadingPopUpBool: any,
    loadingPopOverBool: boolean,
    loadingPopUpBool: boolean,
    setLoadingCTMS: any,
    AmountOfCargoDischagedOnBlur: any,
    setDischargingPopOverBool: any,
    setDischargingPopUpBool: any,
    setDischargingCTMS: any,
    dischargingPopUpBool: boolean,
    dischargingPopOverBool: boolean,
    cargoChangeState: string,
    setCargoChangeState: (value: string) => void;
    previousCargoDetails: boolean;
    setPreviousCargoDetails: (value: boolean) => void;
    editValues?: any,
    setEditValues?: any
    cargoChangePopupBool: boolean
    setCargoChangePopupBool: any;
}

const CargoDetails = ({
    alertBool,
    handleCargoOnboardBlur,
    updateTotalCargoOnboard,
    setLoadingPopOverBool,
    setLoadingPopUpBool,
    loadingPopOverBool,
    loadingPopUpBool,
    setLoadingCTMS,
    AmountOfCargoDischagedOnBlur,
    setDischargingPopOverBool,
    setDischargingPopUpBool,
    setDischargingCTMS,
    dischargingPopUpBool,
    dischargingPopOverBool,
    cargoChangeState,
    setCargoChangeState,
    previousCargoDetails,
    setPreviousCargoDetails,
    editValues,
    setEditValues,
    cargoChangePopupBool,
    setCargoChangePopupBool,
}: CargoDetailsProps) => {
    /** State variables */
    const { discardwarning } = useEditReport();
    const { values, errors, touched, handleChange, handleBlur, setValues }:
        { values: any, errors: any, touched: any, handleChange: any, handleBlur: any, setValues: any } = useFormikContext<any>();
    const { VesselID, ReportID, CurrentVessel, CurrentReport, PreviousReport } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    const cargoDetailsPreviousReport = PreviousReport?.data?.deck_officer?.cargo_detail ?? null;
    const lngCargoROBPreviousReport = PreviousReport?.data?.deck_officer?.lng_cargo_rob ?? null;
    const [refresh, setRefresh] = useState(0);
    /** State variables end */

    /** UseEffect */
    useEffect(() => {
        if (cargoChangeState === "no") {
            setValues({
                ...values,
                cargo_detail: {
                    ...values?.cargo_detail,
                    cargo_detail: cargoDetailsPreviousReport?.cargo_detail,
                    amount_of_cargo_loaded: 0,
                    amount_of_cargo_discharged: 0,
                    total_amount_of_cargo_onboard: cargoDetailsPreviousReport?.total_amount_of_cargo_onboard,
                    cargo_used: 0,
                    cargo_adjusted: 0,
                    adjustment_reason: null,
                }
            });
            setRefresh(refresh + 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cargoChangeState])
    useEffect(() => {
        if (editValues && editValues?.deck_officer?.cargo_detail?.id > 0) {
            setEditValues({
                ...editValues,
                vessel_reporting_information: {
                    ...editValues?.vessel_reporting_information,
                    is_this_cargo_loading_discharging: cargoChangeState,
                },
                deck_officer: {
                    ...editValues?.deck_officer,
                    cargo_detail: values?.cargo_detail
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.cargo_detail])
    /** UseEffect end */

    return (
        <Card className="mb-0 border-0">
            <CardHeader className="py-2 px-0">
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">
                                Cargo Details
                            </h4>
                            <p className="card-title-desc pos-start">
                                All readings since last report
                            </p>
                        </Col>
                        <Col>
                            {currentVesselReport?.reporting_event !== ReportingEvents.NOON_FWE_IP &&
                                currentVesselReport?.reporting_event !== ReportingEvents.DEPARTURE_FROM_BERTH &&
                                <div className="d-flex flex-wrap gap-2 pos-end">
                                    <Label for="is_cargo_change">
                                        Is there any change in cargo onboard?
                                    </Label>
                                    <div className="square-switch sqswitch">
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            key={refresh}
                                            type="checkbox"
                                            switch="none"
                                            name="is_cargo_change"
                                            id="is_cargo_change"
                                            checked={cargoChangeState === "yes" ? true : false}
                                            onChange={(e: any) => {
                                                e.preventDefault();
                                                if (e.target.checked === true) {
                                                    setCargoChangeState("yes");
                                                    setPreviousCargoDetails(true);
                                                } else {
                                                    setCargoChangePopupBool(true);
                                                }
                                            }}
                                        />
                                        <Label
                                            htmlFor="is_cargo_change"
                                            data-on-label="Yes"
                                            data-off-label="No"
                                        />
                                    </div>
                                </div>
                            }
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            <CardBody className="px-0 py-0 mt-2" >
                <Row>
                    <div className='ele_row1 d-flex gap-3'>
                        <div>
                            <Label
                                className="asteric mb-0"
                                for="amount_of_cargo_loaded"
                            >
                                Total cargo loaded
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="amount_of_cargo_loaded_msg"
                                />
                            </Label>
                            <ToolTip
                                target="amount_of_cargo_loaded_msg"
                                message={`${TooltipMsg.Draft_and_Displacement.filter(
                                    (item: any) =>
                                        item.target === "amount_of_cargo_loaded_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="input-group">
                                <Field name="cargo_detail.amount_of_cargo_loaded">
                                    {({ field, form }: FieldProps) => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            key={refresh}
                                            type="text"
                                            className="form-control text-right max-width-7"
                                            id="amount_of_cargo_loaded"
                                            name={field.name}
                                            onBlur={(e: any) => {
                                                handleBlur(e);
                                                if (e.target.value !== null && values?.cargo_detail?.total_amount_of_cargo_onboard !== null) {
                                                    handleCargoOnboardBlur(
                                                        parseFloat(values?.cargo_detail?.total_amount_of_cargo_onboard),
                                                        parseFloat(e.target.value),
                                                        parseFloat(values?.cargo_detail?.amount_of_cargo_discharged)
                                                    );
                                                }
                                                handleChange(e);
                                                if (
                                                    e.target.value !== null &&
                                                    e.target.value > 0
                                                ) {
                                                    form.setFieldValue(
                                                        "cargo_detail.loading",
                                                        true
                                                    );
                                                } else {
                                                    form.setFieldValue(
                                                        "cargo_detail.loading",
                                                        false
                                                    );
                                                }
                                                if (
                                                    CurrentVessel?.vessel_type_precedence_id ===
                                                    VesselTypeConstant.LNG_CARRIER
                                                ) {
                                                    updateTotalCargoOnboard(
                                                        form,
                                                        values,
                                                        e,
                                                        "loading"
                                                    );
                                                }
                                            }}
                                            onChange={(e: any) => {
                                                handleChange(e);
                                                if (
                                                    CurrentVessel?.vessel_type_precedence_id ===
                                                    VesselTypeConstant.LNG_CARRIER
                                                ) {
                                                    updateTotalCargoOnboard(
                                                        form,
                                                        values,
                                                        e,
                                                        "loading"
                                                    );
                                                }
                                            }}
                                            defaultValue={
                                                values?.cargo_detail
                                                    ?.amount_of_cargo_loaded
                                            }
                                            disabled={previousCargoDetails}
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text round_border">
                                    mt
                                </div>
                            </div>
                            {errors?.cargo_detail &&
                                touched?.cargo_detail?.amount_of_cargo_loaded &&
                                errors?.cargo_detail?.amount_of_cargo_loaded &&
                                !alertBool && document.getElementById('amount_of_cargo_loaded') &&
                                env?.form_validation === true && !cargoChangePopupBool && !discardwarning && (
                                    <ErrorTooltip
                                        target="amount_of_cargo_loaded"
                                        message={
                                            errors?.cargo_detail
                                                ?.amount_of_cargo_loaded
                                        }
                                        open={
                                            errors?.cargo_detail &&
                                                errors?.cargo_detail
                                                    ?.amount_of_cargo_loaded && document.getElementById('amount_of_cargo_loaded')
                                                ? true
                                                : false
                                        }
                                    />
                                )}
                            {CurrentVessel?.vessel_type_precedence_id ===
                                VesselTypeConstant.LNG_CARRIER &&
                                values?.cargo_detail?.loading === true && (
                                    <Col sm={12}>
                                        <div className="ele_row1">
                                            <Field name="cargo_detail.loading_completion">
                                                {({ field, form }: FieldProps) => (
                                                    <Input
                                                        onFocus={(e) => e.target.select()}
                                                        type="checkbox"
                                                        id="loading_completion"
                                                        name={field.name}
                                                        onChange={(e: any) => {
                                                            form.setFieldValue(
                                                                field.name,
                                                                e.target.checked
                                                            );
                                                            if (e.target.checked === true) {
                                                                setLoadingPopOverBool(true);
                                                            } else {
                                                                setLoadingPopOverBool(false);
                                                            }
                                                        }}
                                                        defaultChecked={
                                                            values?.cargo_detail
                                                                ?.loading_completion
                                                        }
                                                    />
                                                )}
                                            </Field>
                                            <Label className="ms-2" for="loading_completion">
                                                Is this completion of loading?
                                            </Label>
                                        </div>
                                    </Col>
                                )}
                            {loadingPopOverBool && CurrentVessel?.vessel_type_precedence_id ===
                                VesselTypeConstant.LNG_CARRIER &&
                                values?.cargo_detail?.loading_completion ===
                                true && (
                                    <PopOver
                                        target="loading_completion"
                                        handleClick={() => {
                                            setLoadingPopUpBool(true);
                                            setLoadingPopOverBool(false);
                                        }}
                                        message={"Is loading CTMS available?"}
                                        state={loadingPopOverBool}
                                        setState={setLoadingPopOverBool}
                                    />
                                )}
                            {loadingPopUpBool === true && (
                                <LoadingCTMSContext.Provider
                                    value={setLoadingCTMS}
                                >
                                    <PopUp
                                        state={loadingPopUpBool}
                                        setState={setLoadingPopUpBool}
                                        body={
                                            <LNGCargoQuality
                                                VesselID={VesselID}
                                                cargoOperation={"loading"}
                                                cardHeader={
                                                    "LNG Cargo Loading Quality Details"
                                                }
                                                reportId={ReportID}
                                                setState={setLoadingPopUpBool}
                                            />
                                        }
                                        title={"Loading CTMS Report"}
                                        size="md"
                                    />
                                </LoadingCTMSContext.Provider>
                            )}
                        </div>
                        <div>
                            <Label
                                className="asteric mb-0"
                                for="amount_of_cargo_discharged"
                            >
                                Total cargo discharged
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="amount_of_cargo_discharged_msg"
                                />
                            </Label>
                            <ToolTip
                                target="amount_of_cargo_discharged_msg"
                                message={`${TooltipMsg.Draft_and_Displacement.filter(
                                    (item: any) =>
                                        item.target ===
                                        "amount_of_cargo_discharged_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="input-group">
                                <Field name="cargo_detail.amount_of_cargo_discharged">
                                    {({ field, form }: FieldProps) => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            key={refresh}
                                            type="text"
                                            className="form-control text-right max-width-7"
                                            id="amount_of_cargo_discharged"
                                            name={field.name}
                                            onBlur={(e: any) => {
                                                AmountOfCargoDischagedOnBlur(e, values, handleBlur, handleChange, form)
                                            }}
                                            onChange={(e: any) => {
                                                handleChange(e);
                                                if (
                                                    CurrentVessel?.vessel_type_precedence_id ===
                                                    VesselTypeConstant.LNG_CARRIER
                                                ) {
                                                    updateTotalCargoOnboard(
                                                        form,
                                                        values,
                                                        e,
                                                        "discharging"
                                                    );
                                                }
                                            }}
                                            defaultValue={
                                                values.cargo_detail
                                                    .amount_of_cargo_discharged
                                            }
                                            disabled={previousCargoDetails}
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text round_border">
                                    mt
                                </div>
                            </div>
                            {errors?.cargo_detail &&
                                touched?.cargo_detail
                                    ?.amount_of_cargo_discharged &&
                                errors?.cargo_detail
                                    ?.amount_of_cargo_discharged &&
                                !alertBool && document.getElementById('amount_of_cargo_discharged') &&
                                env?.form_validation === true && !cargoChangePopupBool && !discardwarning && (
                                    <ErrorTooltip
                                        target="amount_of_cargo_discharged"
                                        message={
                                            errors?.cargo_detail
                                                ?.amount_of_cargo_discharged
                                        }
                                        open={
                                            errors?.cargo_detail &&
                                                errors?.cargo_detail
                                                    ?.amount_of_cargo_discharged && document.getElementById('amount_of_cargo_discharged')
                                                ? true
                                                : false
                                        }
                                    />
                                )}
                            {CurrentVessel?.vessel_type_precedence_id ===
                                VesselTypeConstant.LNG_CARRIER &&
                                values?.cargo_detail?.discharging === true && (
                                    <Col sm={12}>
                                        <div className="ele_row1">
                                            <Field name="cargo_detail.discharging_completion">
                                                {({ field, form }: FieldProps) => (
                                                    <Input
                                                        onFocus={(e) => e.target.select()}
                                                        type="checkbox"
                                                        id="discharging_completion"
                                                        name={field.name}
                                                        onChange={(e: any) => {
                                                            form.setFieldValue(
                                                                field.name,
                                                                e.target.checked
                                                            );
                                                            if (e.target.checked === true) {
                                                                setDischargingPopOverBool(true);
                                                            } else {
                                                                setDischargingPopOverBool(false);
                                                            }
                                                        }}
                                                        defaultChecked={
                                                            values?.cargo_detail
                                                                ?.discharging_completion
                                                        }
                                                        disabled={previousCargoDetails}
                                                    />
                                                )}
                                            </Field>
                                            <Label className="ms-2">
                                                Is this completion of discharging?
                                            </Label>
                                        </div>
                                    </Col>
                                )}
                            <br />
                            {CurrentVessel?.vessel_type_precedence_id ===
                                VesselTypeConstant.LNG_CARRIER &&
                                values?.cargo_detail?.discharging_completion ===
                                true && (
                                    <PopOver
                                        target="discharging_completion"
                                        handleClick={() => {
                                            setDischargingPopUpBool(true);
                                            setDischargingPopOverBool(false);
                                        }}
                                        message={"Is discharging CTMS available?"}
                                        state={dischargingPopOverBool}
                                        setState={setDischargingPopOverBool}
                                    />
                                )}
                            {dischargingPopUpBool === true && (
                                <DischargingCTMSContext.Provider
                                    value={setDischargingCTMS}
                                >
                                    <PopUp
                                        state={dischargingPopUpBool}
                                        setState={setDischargingPopUpBool}
                                        body={
                                            <LNGCargoQuality
                                                VesselID={VesselID}
                                                cargoOperation={"discharging"}
                                                cardHeader={
                                                    "LNG Cargo Discharging Quality Details"
                                                }
                                                reportId={ReportID}
                                                setState={setDischargingPopUpBool}
                                            />
                                        }
                                        title={"Discharging CTMS Report"}
                                        size="md"
                                    />
                                </DischargingCTMSContext.Provider>
                            )}
                        </div>
                        <div>
                            <Label
                                className="asteric mb-0"
                                for="total_amount_of_cargo_onboard"
                            >
                                Total cargo onboard
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="total_amount_of_cargo_onboard_msg"
                                />
                            </Label>
                            <ToolTip
                                target="total_amount_of_cargo_onboard_msg"
                                message={`${TooltipMsg.Draft_and_Displacement.filter(
                                    (item: any) =>
                                        item.target ===
                                        "total_amount_of_cargo_onboard_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="input-group">
                                <Field name="cargo_detail.total_amount_of_cargo_onboard">
                                    {({ field }: FieldProps) => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            key={refresh}
                                            type="text"
                                            id="total_amount_of_cargo_onboard"
                                            name={field.name}
                                            className="form-control text-right max-width-7"
                                            onBlur={(e: any) => {
                                                handleCargoOnboardBlur(
                                                    parseFloat(e.target.value),
                                                    parseFloat(values?.cargo_detail?.amount_of_cargo_loaded),
                                                    parseFloat(values?.cargo_detail?.amount_of_cargo_discharged));
                                                handleBlur(e);
                                            }}
                                            onChange={(e: any) => handleChange(e)}
                                            disabled={CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER || previousCargoDetails}
                                            value={
                                                CurrentVessel?.vessel_type_precedence_id !==
                                                    VesselTypeConstant.LNG_CARRIER
                                                    ? values?.cargo_detail
                                                        ?.total_amount_of_cargo_onboard
                                                    : CurrentVessel?.vessel_type_precedence_id ===
                                                        VesselTypeConstant.LNG_CARRIER &&
                                                        Number.isNaN(
                                                            values?.cargo_detail
                                                                ?.total_amount_of_cargo_onboard
                                                        ) === true
                                                        ? null
                                                        : (checkValidObject(lngCargoROBPreviousReport) && lngCargoROBPreviousReport?.id > 0)
                                                            ?
                                                            (parseFloat(lngCargoROBPreviousReport?.cargo_rob ?? 0) +
                                                                parseFloat(values?.cargo_detail?.amount_of_cargo_loaded ?? 0) -
                                                                parseFloat(values?.cargo_detail?.amount_of_cargo_discharged ?? 0) +
                                                                parseFloat(values?.cargo_detail?.cargo_adjusted ?? 0) -
                                                                parseFloat(values?.lng_cargo_rob?.cargo_consumed ?? 0)
                                                            )
                                                            :
                                                            values?.cargo_detail?.total_amount_of_cargo_onboard
                                            }
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text round_border">
                                    mt
                                </div>
                                {errors?.cargo_detail &&
                                    touched?.cargo_detail
                                        ?.total_amount_of_cargo_onboard &&
                                    errors?.cargo_detail
                                        ?.total_amount_of_cargo_onboard &&
                                    !alertBool && document.getElementById('total_amount_of_cargo_onboard') &&
                                    env?.form_validation === true && !cargoChangePopupBool && !discardwarning && (
                                        <ErrorTooltip
                                            target="total_amount_of_cargo_onboard"
                                            message={
                                                errors?.cargo_detail
                                                    ?.total_amount_of_cargo_onboard
                                            }
                                            open={
                                                errors?.cargo_detail &&
                                                    errors?.cargo_detail
                                                        ?.total_amount_of_cargo_onboard && document.getElementById('total_amount_of_cargo_onboard')
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </div>
                        </div>
                        <div>
                            <React.Fragment>
                                <Label
                                    className="asteric mb-0"
                                    for="cargoDetails_cargo_detail"
                                >
                                    Cargo details / comments
                                    <i
                                        className="bx bx-info-circle ml-2p"
                                        id="cargo_detail_msg"
                                    />
                                </Label>
                                <ToolTip
                                    target="cargo_detail_msg"
                                    message={`${TooltipMsg.Draft_and_Displacement.filter(
                                        (item: any) =>
                                            item.target === "cargo_detail_msg"
                                    ).map((tool: any) => {
                                        return tool.message;
                                    })}`}
                                />
                                <span id="cargo_details_comments">
                                    <Field name="cargo_detail.cargo_detail">
                                        {() => (
                                            <textarea
                                                key={refresh}
                                                className="form-control"
                                                name="cargo_detail.cargo_detail"
                                                id="cargoDetails_cargo_detail"
                                                rows={
                                                    values?.cargo_detail?.cargo_detail?.toString()
                                                        ?.length < 10
                                                        ? 1
                                                        : 2
                                                }
                                                onBlur={handleBlur}
                                                onChange={(e: any) => handleChange(e)}
                                                defaultValue={
                                                    values?.cargo_detail?.cargo_detail
                                                }
                                                disabled={previousCargoDetails}
                                            />
                                        )}
                                    </Field>
                                </span>
                                {errors?.cargo_detail &&
                                    touched?.cargo_detail?.cargo_detail &&
                                    errors?.cargo_detail?.cargo_detail &&
                                    !alertBool && document.getElementById("cargoDetails_cargo_detail") !== null &&
                                    env?.form_validation === true && !cargoChangePopupBool && !discardwarning && (
                                        <ErrorTooltip
                                            target="cargo_details_comments"
                                            message={
                                                errors?.cargo_detail?.cargo_detail
                                            }
                                            open={
                                                errors?.cargo_detail &&
                                                    errors?.cargo_detail?.cargo_detail
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </React.Fragment>
                        </div>
                    </div>
                </Row>
                {CurrentVessel?.vessel_type_precedence_id ===
                    VesselTypeConstant.LNG_CARRIER && (
                        <Row className="mb-3">
                            <Col sm={2}>
                                <>
                                    <Label className="mb-0" for="cargo_adjusted">
                                        Cargo adjusted
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="cargo_adjusted_msg"
                                        ></i>
                                    </Label>
                                    <ToolTip
                                        target="cargo_adjusted_msg"
                                        message={`${TooltipMsg.Draft_and_Displacement.filter(
                                            (item: any) =>
                                                item.target === "cargo_adjusted_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                    <div className="input-group">
                                        <Field name="cargo_detail.cargo_adjusted">
                                            {({ field, form }: FieldProps) => (
                                                <Input
                                                    onFocus={(e) => e.target.select()}
                                                    type="text"
                                                    className="form-control text-right"
                                                    id="cargo_adjusted"
                                                    name={field.name}
                                                    onBlur={(e: any) => {
                                                        handleBlur(e);
                                                        handleChange(e);
                                                        updateTotalCargoOnboard(
                                                            form,
                                                            values,
                                                            e,
                                                            "adjusted"
                                                        );
                                                    }}
                                                    onChange={(e: any) => {
                                                        updateTotalCargoOnboard(
                                                            form,
                                                            values,
                                                            e,
                                                            "adjusted"
                                                        );
                                                    }}
                                                    defaultValue={
                                                        values.cargo_detail.cargo_adjusted
                                                    }
                                                    disabled={previousCargoDetails}
                                                />
                                            )}
                                        </Field>
                                        <div className="input-group-text round_border">
                                            mt
                                        </div>
                                    </div>
                                    {errors?.cargo_detail &&
                                        touched?.cargo_detail?.cargo_adjusted &&
                                        errors?.cargo_detail?.cargo_adjusted &&
                                        !alertBool &&
                                        env?.form_validation === true && !discardwarning && (
                                            <ErrorTooltip
                                                target="cargo_adjusted"
                                                message={
                                                    errors?.cargo_detail?.cargo_adjusted
                                                }
                                                open={
                                                    errors?.cargo_detail &&
                                                        errors?.cargo_detail?.cargo_adjusted
                                                        ? true
                                                        : false
                                                }
                                            />
                                        )}
                                </>
                            </Col>
                            <Col sm={2}>
                                <Label className="mb-0">Cargo used</Label>
                                <div className="input-group">
                                    {" "}
                                    <Field
                                        type="text"
                                        name="lng_cargo_rob.cargo_consumed"
                                        id="lng_cargo_rob.cargo_consumed"
                                        className="form-control text-right"
                                        disabled
                                    />
                                    <div className="input-group-text round_border">
                                        mt
                                    </div>
                                </div>
                            </Col>
                            <Col sm={3}>
                                <Label
                                    className="asteric mb-0"
                                    for="adjustment_reason"
                                >
                                    Reason for cargo adjustment
                                    <i
                                        className="bx bx-info-circle ml-2p"
                                        id="adjustment_reason_msg"
                                    />
                                </Label>
                                <ToolTip
                                    target="adjustment_reason_msg"
                                    message={`${TooltipMsg.Draft_and_Displacement.filter(
                                        (item: any) =>
                                            item.target === "adjustment_reason_msg"
                                    ).map((tool: any) => {
                                        return tool.message;
                                    })}`}
                                />
                                <Field name="cargo_detail.adjustment_reason">
                                    {() => (
                                        <textarea
                                            className="form-control"
                                            id="adjustment_reason"
                                            name="cargo_detail.adjustment_reason"
                                            rows={
                                                values?.cargo_detail?.adjustment_reason?.toString()
                                                    ?.length < 10
                                                    ? 1
                                                    : 2
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e: any) => handleChange(e)}
                                            defaultValue={
                                                values?.cargo_detail?.adjustment_reason
                                            }
                                            disabled={
                                                (values?.cargo_detail?.cargo_adjusted ===
                                                    0 ||
                                                    values?.cargo_detail?.cargo_adjusted ===
                                                    "0")
                                                || previousCargoDetails
                                            }
                                        />
                                    )}
                                </Field>
                                {errors?.cargo_detail &&
                                    touched?.cargo_detail?.adjustment_reason &&
                                    errors?.cargo_detail?.adjustment_reason &&
                                    !alertBool &&
                                    env?.form_validation === true && !discardwarning && (
                                        <ErrorTooltip
                                            target="adjustment_reason"
                                            message={
                                                errors?.cargo_detail?.adjustment_reason
                                            }
                                            open={
                                                errors?.cargo_detail &&
                                                    errors?.cargo_detail?.adjustment_reason
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </Col>
                        </Row>
                    )}
            </CardBody>
            <PopUp
                state={cargoChangePopupBool}
                setState={setCargoChangePopupBool}
                title={"Cargo Change"}
                size={"sm"}
                body={
                    <React.Fragment>
                        <p className="mb-3">
                            By selecting <strong>'No change in cargo details'</strong>, the current details will be replaced with those from the previous report.
                            <br /><br />
                            Do you agree to proceed with this change?
                        </p>
                        <div className="d-flex justify-content-end gap-2">
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setValues({
                                        ...values,
                                        bill_of_lading: {
                                            ...values?.bill_of_lading,
                                            is_bill_of_lading_issued_since_last_report: false,
                                            cargo_survey: false,
                                            ship_figure_of_bl_figure: 0,
                                            bl_figure: 0,
                                            surveyor_figure_of_bl_figure: 0,
                                            bl_figure_file: null,
                                        }
                                    });
                                    setCargoChangePopupBool(false);
                                    setCargoChangeState("no");
                                    if ((currentVesselReport?.reporting_event !== ReportingEvents.NOON_FWE_IP && currentVesselReport?.reporting_event !== ReportingEvents.DEPARTURE_FROM_BERTH &&
                                        cargoChangeState === "no")) {
                                        setPreviousCargoDetails(false);
                                    } else {
                                        setPreviousCargoDetails(true);
                                    }
                                    setRefresh(refresh + 1);
                                }}
                            >
                                Yes
                            </button>
                            <button
                                className="btn btn-danger"
                                onClick={() => {
                                    setCargoChangePopupBool(false);
                                    setRefresh(refresh + 1);
                                }}
                            >
                                No
                            </button>
                        </div>
                    </React.Fragment>
                }
            />
        </Card>
    )
}

export default CargoDetails